import { Button, Card, Col, Form, Input, InputNumber, Layout, message, Row, Select, Typography } from "antd";
import { Descriptions } from "antd/es";
import { postData } from "apiServices/common";
import AppPageHeader from "common/PageHeader";
import dayjs from "dayjs";
import { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router";
import { useLocation } from "react-router-dom";

const UpdateFinishingHourlyIron = (props) => {
  const { type } = props;
  const [sewingDetails, setSewingDetails] = useState();
  const [sewingEntries, setSewingEntries] = useState([]);
  const [totalQuantity, setTotalQuantity] = useState(0);

  const location = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();

  const { folding_type, activeTab } = location.state || {};

  console.log("🚀 ~ UpdateFinishingHourlyIron ~ folding_type:", folding_type);
  console.log("🚀 ~ UpdateFinishingHourlyIron ~ folding_type:", activeTab);

  const searchParams = new URLSearchParams(location.search);
  const entry_date = searchParams.get("entry_date");
  const finishing_line_id = searchParams.get("finishing_line_id");
  const supervisor_id = searchParams.get("supervisor_id");
  const style_id = searchParams.get("style_id");
  const sales_contract_id = searchParams.get("sales_contract_id");
  const buying_office_id = searchParams.get("buying_office_id");
  const buyer_id = searchParams.get("buyer_id");
  const sub_contract_factory_id = searchParams.get("sub_contract_factory_id");
  const sub_style_id = searchParams.get("sub_style_id");
  const po_map_id = searchParams.get("po_map_id");
  const color_id = searchParams.get("color_id");
  const size_id = searchParams.get("size_id");
  const frp_id = searchParams.get("frp_id");
  const operator_id = searchParams.get("operator_id");
  const entry_time = searchParams.get("entry_time");
  const hour_time_range_from = searchParams.get("hour_time_range_from");
  const hour_time_range_to = searchParams.get("hour_time_range_to");
  const hour = searchParams.get("hour");

  const payload = useMemo(() => {
    const baseData = {
      entry_date: dayjs(entry_date).format("YYYY-MM-DD"),
      finishing_line_id: finishing_line_id ? parseInt(finishing_line_id, 10) : null,
      supervisor_id: supervisor_id ? parseInt(supervisor_id, 10) : null,
      style_id: style_id ? parseInt(style_id, 10) : null,
      sales_contract_id: sales_contract_id ? parseInt(sales_contract_id, 10) : null,
      buying_office_id: buying_office_id ? parseInt(buying_office_id, 10) : null,
      buyer_id: buyer_id ? parseInt(buyer_id, 10) : null,
      sub_contract_factory_id: sub_contract_factory_id ? parseInt(sub_contract_factory_id, 10) : null,
      sub_style_id: sub_style_id ? parseInt(sub_style_id, 10) : null,
      po_map_id: po_map_id ? parseInt(po_map_id, 10) : null,
      color_id: color_id ? parseInt(color_id, 10) : null,
      entry_time: entry_time || null,
    };

    if (activeTab === "assort") {
      return {
        ...baseData,
        hour: hour ? parseInt(hour, 10) : null,
        frp_id: frp_id ? parseInt(frp_id, 10) : null,
        operator_id: operator_id ? parseInt(operator_id, 10) : null,
      };
    }

    return {
      ...baseData,
      size_id: size_id ? parseInt(size_id, 10) : null,
    };
  }, [
    activeTab,
    buyer_id,
    buying_office_id,
    color_id,
    entry_date,
    finishing_line_id,
    frp_id,
    id,
    operator_id,
    po_map_id,
    sales_contract_id,
    size_id,
    style_id,
    sub_contract_factory_id,
    sub_style_id,
    supervisor_id,
  ]);

  const [form] = Form.useForm();

  const handleSubmit = async (values) => {
    const entries = values?.sewingEntries || [];
    const isAssortTab = activeTab === "assort";

    const details = entries.map((entry) => ({
      id: entry.id || null,
      operator_id: entry.operator_id ? parseInt(entry.operator_id, 10) : null,
      assort_poly_id: isAssortTab && entry.assortment_poly_id ? parseInt(entry.assortment_poly_id, 10) : null,
      quantity: isAssortTab ? entry.assortment_qty ?? 0 : entry.quantity ?? 0,
    }));

    const payload = {
      entry_date: sewingDetails?.entry_date ?? (entry_date ? dayjs(entry_date).format("YYYY-MM-DD") : null),
      // entry_time: sewingDetails?.entry_time ?? (sewingDetails?.hour ? `${sewingDetails.hour}` : entries?.[0]?.entry_time ?? null),
      entry_time: entry_time || null,
      finishing_line_id: finishing_line_id ? parseInt(finishing_line_id, 10) : null,
      style_id: style_id ? parseInt(style_id, 10) : null,
      sales_contract_id: sales_contract_id ? parseInt(sales_contract_id, 10) : null,
      buying_office_id: buying_office_id ? parseInt(buying_office_id, 10) : null,
      buyer_id: buyer_id ? parseInt(buyer_id, 10) : null,
      sub_contract_factory_id: sub_contract_factory_id ? parseInt(sub_contract_factory_id, 10) : null,
      sub_style_id: sub_style_id ? parseInt(sub_style_id, 10) : null,
      po_map_id: po_map_id ? parseInt(po_map_id, 10) : null,
      color_id: color_id ? parseInt(color_id, 10) : null,
      size_id:
        folding_type?.toLowerCase() === "solid" || !isAssortTab ? (size_id ? parseInt(size_id, 10) : null) : null,
      folding_type: folding_type || (isAssortTab ? "Assort Size" : "Solid"),
      details,
      supervisor_id: supervisor_id ? parseInt(supervisor_id, 10) : null,
      hour: parseInt(hour, 10) || null,
    };

    try {
      const response = await postData(`/api/digitalization/single-group-wise-${type}-update`, payload);

      if (response?.code === 200) {
        message.success("Updated successfully");
        navigate(`/digitalization/finishing/hourly-${type}`);
      }
    } catch (error) {
      message.error("Failed to update");
    }
  };

  const extra = (
    <div className="extra-button-container">
      <Button
        size="small"
        htmlType="submit"
        style={{ marginRight: 5 }}
        onClick={() => {
          form.resetFields();
          navigate(`/digitalization/finishing/hourly-${type}`);
        }}
      >
        {" "}
        Back
      </Button>
      <Button htmlType="submit" type="primary" size="small" onClick={() => form.submit()}>
        {" "}
        Save
      </Button>
    </div>
  );

  const calculateTotalQuantity = (values) => {
    if (!values?.sewingEntries) return 0;
    return values.sewingEntries.reduce((sum, entry) => sum + (entry.quantity || 0), 0);
  };

  const handleFormChange = (changedValues, allValues) => {
    const newTotal = calculateTotalQuantity(allValues);
    setTotalQuantity(newTotal);
  };

  useEffect(() => {
    if (id) {
      const fetchSewingDetails = async () => {
        try {
          const apiEndpoint =
            activeTab === "assort"
              ? `/api/digitalization/${type}-single-assort-edit-view`
              : `/api/digitalization/single-group-wise-${type}-update-view`;

          const response = await postData(apiEndpoint, payload);
          const data = response?.data?.data ?? response?.data;
          const normalizedRecords =
            Array.isArray(data?.records) && data.records.length
              ? data.records
              : activeTab === "assort" && data
              ? [data]
              : [];
          const normalizedTotalQty =
            typeof data?.total_qty === "number"
              ? data.total_qty
              : normalizedRecords.reduce(
                  (sum, item) => sum + (item.quantity ?? item[`${type}_details`]?.poly_quantity ?? 0),
                  0,
                );

          setSewingDetails(data);
          setSewingEntries(normalizedRecords);
          setTotalQuantity(normalizedTotalQty);

          form.setFieldsValue({
            sewingEntries: normalizedRecords.map((item) => {
              const operatorName = item.operator_info?.name || item.operator?.name || data?.operator?.name || "N/A";
              const operatorCard =
                item.operator_info?.additional_info?.id_card_no ||
                item.operator?.additional_info?.id_card_no ||
                data?.operator?.additional_info?.id_card_no ||
                null;

              const baseEntry = {
                id: item.id,
                entry_time:
                  item.hour_time_range_from && item.hour_time_range_to
                    ? `${item.hour_time_range_from} - ${item.hour_time_range_to}`
                    : hour_time_range_from && hour_time_range_to
                    ? `${hour_time_range_from} - ${hour_time_range_to}`
                    : data?.hour
                    ? `${data.hour}`
                    : "N/A",
                quantity: item.quantity ?? item[`${type}_details`]?.poly_quantity ?? 0,
                operator_name: operatorCard ? `${operatorName} (${operatorCard})` : operatorName,
                operator_id:
                  item.operator_id || item.operator_info?.id || item.operator?.id || data?.operator?.id || null,
              };

              if (activeTab === "assort") {
                return {
                  ...baseEntry,
                  assortment_poly: item[`${type}_details`]?.folding_requirement_poly?.ratio_name || null,
                  assortment_qty: item[`${type}_details`]?.poly_quantity ?? item.quantity ?? 0,
                  assortment_poly_id:
                    item[`${type}_details`]?.folding_requirement_poly?.id || item[`${type}_details`]?.frp_id || null,
                };
              }
              return baseEntry;
            }),
          });
        } catch (error) {
          message.error("Failed to fetch details");
          setSewingDetails(null);
        }
      };
      fetchSewingDetails();
    }
  }, [id, form, activeTab, payload, type]);

  return (
    <>
      <AppPageHeader
        title={
          <Typography.Title level={5} style={{ textTransform: "capitalize" }}>
            Update Hourly {type} Entry ({activeTab || "Unknown"})
          </Typography.Title>
        }
        extra={extra}
      />

      <Layout.Content className="item-details">
        <Card title="Entry Details" bordered={false} style={{ marginTop: 5 }}>
          {sewingDetails && (
            <Descriptions column={4}>
              <Descriptions.Item label="Finishing Line">{sewingDetails.finishing_line?.name}</Descriptions.Item>
              <Descriptions.Item label="Supervisor">{sewingDetails.supervisor?.name}</Descriptions.Item>
              <Descriptions.Item label="Style">{sewingDetails.style?.style_no}</Descriptions.Item>
              <Descriptions.Item label="Style Description">{sewingDetails.style?.description}</Descriptions.Item>
              <Descriptions.Item label="Sub Style">{sewingDetails.sub_style?.sub_style_no}</Descriptions.Item>
              <Descriptions.Item label="Sales Contract">{sewingDetails.sales_contract?.reference_no}</Descriptions.Item>
              <Descriptions.Item label="Buying Office">{sewingDetails.buying_office?.name}</Descriptions.Item>
              <Descriptions.Item label="Buyer">{sewingDetails.buyer?.name}</Descriptions.Item>
              <Descriptions.Item label="PO">{sewingDetails.po_map?.original_po}</Descriptions.Item>
              <Descriptions.Item label="Color">{sewingDetails.color?.name}</Descriptions.Item>
              {activeTab !== "assort" && (
                <>
                  <Descriptions.Item label="Size">{sewingDetails.size?.name}</Descriptions.Item>
                  <Descriptions.Item label="Total Quantity">{totalQuantity}</Descriptions.Item>
                </>
              )}
            </Descriptions>
          )}
        </Card>

        <Card title="Entry Details" style={{ marginTop: 20 }} bordered={false}>
          <Form form={form} layout="vertical" onFinish={handleSubmit} onValuesChange={handleFormChange}>
            <Form.List name="sewingEntries">
              {(fields) => (
                <>
                  {fields.map(({ key, name, fieldKey, ...restField }) => {
                    const currentEntry = sewingEntries?.[name];
                    const ratioName =
                      currentEntry?.[`${type}_details`]?.folding_requirement_poly?.ratio_name ??
                      currentEntry?.assortment_poly ??
                      sewingDetails?.[`${type}_details`]?.folding_requirement_poly?.ratio_name;
                    const isAssort = activeTab === "assort";
                    const operatorDisplay = form.getFieldValue(["sewingEntries", name, "operator_name"]) || "N/A";

                    return (
                      <Card key={key} style={{ marginTop: 10 }}>
                        <Row gutter={16} align="middle">
                          <Col span={isAssort ? 6 : 8}>
                            <Form.Item
                              {...restField}
                              name={[name, "operator_name"]}
                              fieldKey={[fieldKey, "operator_name"]}
                              label="Operator Name"
                            >
                              <Select
                                disabled
                                options={[
                                  {
                                    label: operatorDisplay,
                                    value: operatorDisplay,
                                  },
                                ]}
                                placeholder="Operator not available"
                              />
                            </Form.Item>
                            <Form.Item
                              {...restField}
                              name={[name, "operator_id"]}
                              fieldKey={[fieldKey, "operator_id"]}
                              hidden
                            >
                              <Input />
                            </Form.Item>
                          </Col>

                          <Col span={isAssort ? 6 : 8}>
                            <Form.Item
                              {...restField}
                              name={[name, "entry_time"]}
                              fieldKey={[fieldKey, "entry_time"]}
                              label={isAssort ? "Hourly Target " : "Time Range"}
                            >
                              <Input disabled />
                            </Form.Item>
                          </Col>

                          {!isAssort && (
                            <Col span={isAssort ? 4 : 8}>
                              <Form.Item
                                {...restField}
                                name={[name, "quantity"]}
                                fieldKey={[fieldKey, "quantity"]}
                                label="Quantity"
                                rules={[
                                  {
                                    required: true,
                                    message: "Quantity is required",
                                  },
                                ]}
                              >
                                <InputNumber style={{ width: "100%" }} />
                              </Form.Item>
                            </Col>
                          )}

                          {isAssort && (
                            <>
                              <Col span={6}>
                                <Form.Item
                                  {...restField}
                                  name={[name, "assortment_poly"]}
                                  fieldKey={[fieldKey, "assortment_poly"]}
                                  label="Assorment Poly"
                                >
                                  <Select
                                    disabled
                                    options={
                                      ratioName
                                        ? [
                                            {
                                              label: ratioName,
                                              value: ratioName,
                                            },
                                          ]
                                        : []
                                    }
                                    placeholder="No poly data"
                                  />
                                </Form.Item>
                                <Form.Item
                                  {...restField}
                                  name={[name, "assortment_poly_id"]}
                                  fieldKey={[fieldKey, "assortment_poly_id"]}
                                  hidden
                                >
                                  <Input />
                                </Form.Item>
                              </Col>
                              <Col span={6}>
                                <Form.Item
                                  {...restField}
                                  name={[name, "assortment_qty"]}
                                  fieldKey={[fieldKey, "assortment_qty"]}
                                  label="Assorment Qty"
                                  rules={[
                                    {
                                      required: true,
                                      message: "Assorment qty is required",
                                    },
                                  ]}
                                >
                                  <InputNumber style={{ width: "100%" }} />
                                </Form.Item>
                              </Col>
                            </>
                          )}
                        </Row>
                      </Card>
                    );
                  })}
                </>
              )}
            </Form.List>
            {/* <Form.Item style={{ marginTop: 20 }}>
              <Button type="primary" htmlType="submit">
                Submit
              </Button>
            </Form.Item> */}
          </Form>
        </Card>
      </Layout.Content>
    </>
  );
};

export default UpdateFinishingHourlyIron;
